import AxiosInstance from "./AxiosInstance";

const Login = async ({ email, password }) => {
  try {
    const response = await AxiosInstance.get(`/admin_user/data`, {
      params: { email, password },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};


export default Login;
